module.exports = __webpack_public_path__ + "images/21c22ef934300d41753ef0a6f779f743.svg";